// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Input, Component, OnInit } from '@angular/core';
import { ProjectDetail } from '@app/core';

@Component({
  selector: 'app-project-column',
  templateUrl: './project-column.component.html',
  styleUrls: ['./project-column.component.scss']
})
export class ProjectColumnComponent implements OnInit {
  @Input() project: ProjectDetail | undefined = undefined;
  @Input() showBackButton = false;

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/project-column/project-column.component.ts